<template>
  <div class="ai_chat">
    <div class="d-flex flex-wrap">
      <TalkingIdol class="talkingIdol d-none d-xl-block" :selectedIdx="TalkingIdolIdx"  />
      <div class="swiper_item flex-1">
        <div class="slider-banner position-relative">
          <div class="swiper" ref="mySwiper">
            <div v-show="isBegin" class="swiper-item">
              <Orally_speaking_header :isBegin="isBegin" :selectedStep="0" v-on:reStart="reStart" />

              <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent">
                <div v-if="chatObj.length > 0">
                  <div v-for="(item, index) in chatObj" :key="index">
                    <RobotDialogue :isSelectedType="false" :itemData="item" :isBegin="isBegin" :selectedStep="selectedStep" class="mb-3" v-if="item.role === 'robot'" v-on:selectAnswer="selectAnswer" v-on:selectType="selectType" />
                    <SelfDialogue :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                    <RobotDialogue :isSelectedType="true" :selectedAns="selectedAns" :selectedAns2="selectedAns2" v-if="index === chatObj.length - 1 && (selectedAns && selectedAns2)" v-on:selectType="selectType" />
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-show="!isBegin" class="swiper-item">
              <Orally_speaking_header :isBegin="isBegin" :selectedStep="0" v-on:reStart="reStart" :selectedAns="selectedAns" :selectedAns2="selectedAns2"  />

              <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent1">
                <div v-if="follow_upObj.length > 0">
                  <div v-for="(item, index) in follow_upObj" :key="index">
                    <RobotDialogue :selectedStep="0" :itemData="item" class="mb-3" v-if="item.role === 'robot'" />
                    <SelfDialogue :selectedStep="0" :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                  </div>
                </div>
              </div>

              <div class="follow-btn d-flex justify-content-center w-100 align-items-center text-lg">
                <a @click="generateSentence" class="pointer flex-1 d-flex bg-chat-purple font-bold text-white justify-content-center align-items-center">
                  <img src="@/assets/image/ai/icon_re.png" alt="" class="mr-1"><p>繼續練習 Continue</p>
                </a>
                <a @click="toSlide(1)" class="pointer flex-1 d-flex bg-chat-green font-bold text-white justify-content-center align-items-center py-1">
                  <p>對話練習 Conversation</p><img src="@/assets/image/ai/arrow_R.png" alt="" class="ml-1">
                </a>
              </div>
            </div> -->
            <div v-show="!isBegin" class="swiper-item">
              <div class="w-100 position-relative d-flex">
              <div class="w-100">
                <Orally_speaking_header :isBegin="isBegin" :selectedStep="1" v-on:reStart="reStart" :selectedAns="selectedAns" :selectedAns2="selectedAns2" />

                <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent2">

                  <div v-if="conversationObj.length > 0">
                    <div v-for="(item, index) in conversationObj" :key="index">
                      <RobotDialogue :chatHistory="chatHistory[index]" :itemIdx="index" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'robot'" v-on:endTyped="scrollToBottom" v-on:emitTalkIdolIdx="emitTalkIdolIdx" />
                      <SelfDialogue :chatHistory="chatHistory[index]" :theme="theme" :context="context" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                    </div>
                  </div>
                </div>

                <div class="chat-button d-flex justify-content-center w-100 align-items-center">
                  <a class="ai-suggest-button pointer tooltip-outer d-none d-lg-inline-block" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                    <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isTranslateBtn">
                    <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="w-100 h-auto d-inline-block" v-if="isTranslateBtn">
                    <span class="tooltiptext_left">中文輸入</span>
                  </a>
                  <a class="ai-suggest-button pointer tooltip-outer d-none d-lg-inline-block" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                    <img src="@/assets/image/ai/AI_A.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isAiSuggest">
                    <img src="@/assets/image/ai/AI_A_active.png" alt="" class="w-100 h-auto d-inline-block" v-if="isAiSuggest">
                    <span class="tooltiptext">AI代答</span>
                  </a>
                  <SpeechRecognition ref="speechRecognition" :isDisabledInput="speechInputDisabled" v-on:speechCountDown="speechCountDown" v-on:emitSpeechRecognition="emitSpeechRecognition" v-on:speechStatus="speechStatus = $event" v-if="isOpenKeyboard" />

                  <div class="chat-button-input d-flex align-items-center flex-1 p-2 pr-4 bg-white" v-if="isOpenKeyboard">
                    <a v-if="!isSpeechRecognition" class="keyboard-btn notOpenKeyboard d-block mr-2 p-2 px-3">
                      <img src="@/assets/image/ai/notOpenKeyboard.png" alt="" class="">
                    </a>
                    <p class="mr-2 p-2 text-sm" v-if="isSpeechRecognition">{{ speechCount }}s</p>
                    <input ref="input3" :disabled="speechInputDisabled || speechStatus.busy" type="text" class="w-100 border-0 focus:outline-none" v-model="speechInputText" @keyup.enter="inputText3" placeholder="請點「麥克風」開始錄音應答，或點「AI」生成回應建議。">
                    <button type="button" class="speech-submit pointer ml-2 tooltip-outer d-inline-block" @click="inputText3()" :disabled="speechInputDisabled || speechStatus.busy" :class="{ 'opacity-50': speechInputDisabled || speechStatus.busy }" aria-label="送出"><img src="@/assets/image/ai/submit_icon.png" alt="" class="">
                      <span class="tooltiptext">送出</span>
                    </button>
                  </div>

                </div>
                <div class="d-flex aiSuggestDialogue">
                  <a class="translate-suggest-button mr-1 d-mr-2 ai-suggest-button pointer tooltip-outer d-lg-none" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                    <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isTranslateBtn">
                    <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="w-100 h-auto d-inline-block" v-if="isTranslateBtn">
                    <span class="tooltiptext_left">中文輸入</span>
                  </a>
                  <a class="mr-1 d-mr-2 ai-suggest-button pointer tooltip-outer d-lg-none" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                    <img src="@/assets/image/ai/AI_A.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isAiSuggest">
                    <img src="@/assets/image/ai/AI_A_active.png" alt="" class="w-100 h-auto d-inline-block" v-if="isAiSuggest">
                    <span class="tooltiptext">AI代答</span>
                  </a>

                  <AiSuggestDialogue :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isAiSuggest" />
                  <TranslateDialogue :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isTranslateBtn" v-on:swal_failPopAPI="swal_failPopAPI" />
                </div>

              </div>

            </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="swiper_rule flex-1">
        <Rule />
      </div> -->
      <div>
        <a class="tips_btn d-inline-block pointer mt-5" @click="toggleTips">
          <img src="@/assets/image/ai/tips_btn.png" alt="" class=" object-contain">
        </a>
        <testingToolsSWAL />
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/store/api'
import Orally_speaking_header from '@/components/AiHelper/chat/orally_speaking_header'
import RobotDialogue from '@/components/AiHelper/chat/robotDialogue'
import SelfDialogue from '@/components/AiHelper/chat/selfDialogue'
import AiSuggestDialogue from '@/components/AiHelper/chat/aiSuggestDialogue'
import TranslateDialogue from '@/components/AiHelper/chat/translateDialogue'
import SpeechRecognition from '@/components/AiHelper/chat/SpeechRecognition'
import liveSpeechInput from '@/components/AiHelper/chat/liveSpeechInput'
import allJs from '@/components/AiHelper/all.js'
// import Rule from '@/components/AiHelper/rule.vue'
import { mapGetters } from 'vuex'
import TalkingIdol from '@/components/AiHelper/chat/TalkingIdol'
import testingToolsSWAL from '@/components/AiHelper/chat/testingToolsSWAL'
export default {
  name: 'chat_ai',
  components: {
    RobotDialogue,
    SelfDialogue,
    AiSuggestDialogue,
    TranslateDialogue,
    Orally_speaking_header,
    SpeechRecognition,
    // Rule,
    TalkingIdol,
    testingToolsSWAL
  },
  data () {
    return {
      chatJSon: null,
      selectedStep: 0,
      isOpenKeyboard: true,
      isTips: false,

      isBegin: true,
      isAiSuggest: false,
      isTranslateBtn: false,

      isDisbaledInput: true,

      recorder: null,
      playTime: 0,
      timer: null,
      src: null,
      isRecorder: false,

      session_id: null,
      prompt_id: null,
      pageTitle: '',
      chatRevision: 0,
      isLoadingCategories: false,

      selfText: '',

      selectedAns: null,
      selectedAns2: null,

      chatObj: [],

      follow_upObj: [],

      conversationObj: [],

      element2OffsetHeight: null,

      speechCount: null,
      isSpeechRecognition: false,

      carousel_left: 0,

      lastChatResult: null,

      isGettingChatsCreate: false,
      isSendingChat: false,

      chatHistory: [],

      audio_id: '',

      playbackRate: 1,

      TalkingIdolIdx: 0
    }
  },
  mixins: [
    allJs,
    liveSpeechInput
  ],
  computed: {
    speechInputDisabled () {
      return this.isBegin || this.isLoadingCategories || !this.session_id || this.isGettingChatsCreate || this.isSendingChat || this.remainPoints < 1
    },
    promptIdForApi () {
      return this.$route.params.promptId
    },
    ...mapGetters([
      'remainPoints'
    ]),
    theme () {
      let self = this
      if (self.selectedAns && self.selectedAns2 && self.selectedStep === 0) {
        return self.selectedAns2.theme
      } else if (self.selectedAns && self.selectedAns2 && self.selectedStep === 1) {
        return self.selectedAns2.theme
      }
      return ''

    },
    context () {
      let self = this
      if (self.selectedAns && self.selectedAns2 && self.selectedStep === 0) {
        return self.selectedAns2.context
      } else if (self.selectedAns && self.selectedAns2 && self.selectedStep === 1) {
        return self.selectedAns2.context
      }
      return ''
    },
    context2 () {
      let self = this
      if (self.selectedAns && self.selectedAns2 && self.selectedStep === 0) {
        return self.selectedAns2.context2
      } else if (self.selectedAns && self.selectedAns2 && self.selectedStep === 1) {
        return self.selectedAns2.context2
      }
      return ''
    },
    isDisablesByPoints () {
      let self = this
      if (self.remainPoints < 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.getCategories()
  },
  mounted () {
  },
  watch: {
    '$route.fullPath' () { this.resetSpeechDraft() },
    'conversationObj': {
      handler (newVal, oldVal) {
        let self = this
        if (newVal !== oldVal) {
          self.scrollToBottom()
        }
      },
      deep: true,
      immediate: true
    }
  },
  updated () {
    this.scrollToBottom()
  },
  beforeDestroy () {
    this.chatRevision++
    this.cancelSpeechRecording()
  },
  methods: {
    resetSpeechDraft () {
      this.cancelSpeechRecording()
      this.selfText = ''
      this.audio_id = ''
    },
    async getCategories () {
      const revision = this.chatRevision
      const promptId = this.promptIdForApi
      const path = promptId ? `/ai/categories/${promptId}` : '/ai/categories'
      const options = { headers: { showLoading: false } }
      const obj = { role: 'robot', text: '', options: null, isLoading: true }

      this.isLoadingCategories = true
      this.isBegin = !promptId
      this.selectedStep = promptId ? 1 : 0
      const messages = promptId ? this.conversationObj : this.chatObj
      messages.push(obj)

      try {
        const res = await api.get(path, options)
        if (revision !== this.chatRevision) return

        const data = res.data.data
        if (promptId && !res.data.prompt_id) throw new Error('Missing conversation prompt_id')
        // The original Japanese practice must keep using /ai/chats/create.
        this.prompt_id = promptId ? res.data.prompt_id : null
        this.pageTitle = res.data.name || ''

        // production returns a single context for free conversation, with no choices.
        if (promptId && data && data.context && data.context2) {
          this.chatObj = []
          this.conversationObj = []
          this.selectedAns = data
          this.selectedAns2 = data
          this.selectedStep = 1
          this.isBegin = false
          await this.chatsCreate()
          return
        }

        this.chatJSon = data
        this.conversationObj = []
        this.chatObj = [obj]
        this.isBegin = true
        this.selectedStep = 0
        obj.text = '請選擇主題，來場零壓力的互動對話練習吧！'
        obj.options = data
        obj.isLoading = false
      } catch (err) {
        if (revision !== this.chatRevision) return
        obj.isLoading = false
        obj.text = '無法載入練習，請點「重新開始」再試一次。'
        console.log(err)
      } finally {
        if (revision === this.chatRevision) this.isLoadingCategories = false
      }
    },

    emitSpeechRecognition (emitSpeechRecognition) {
      let self = this

      if (emitSpeechRecognition && emitSpeechRecognition.result && !self.speechInputDisabled) {
        self.selfText = self.appendSpeechText(emitSpeechRecognition.result)

        self.audio_id = emitSpeechRecognition.id

        self.$nextTick(() => {
          if (self.$refs.input3 && !self.$refs.input3.disabled) self.$refs.input3.focus()
        })
      }
    },

    // emitSpeechRecognition2 (emitSpeechRecognition2) {
    //   let self = this
    //   if (emitSpeechRecognition2) {
    //     self.selfText = self.selfText + emitSpeechRecognition2.result

    //     self.audio_id = emitSpeechRecognition2.id
    //   }
    //   if (self.isBegin) {
    //     self.inputText()
    //   } else {
    //     self.inputText3()
    //   }
    // },

    async chatsCreate () {
      // 會話開始
      let self = this
      if (self.isGettingChatsCreate) return
      const revision = self.chatRevision

      const usePromptApi = Boolean(self.promptIdForApi && self.prompt_id)
      let path = usePromptApi ? `/ai/generate/${self.prompt_id}` : '/ai/chats/create'

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      self.conversationObj.push(obj)

      const options = { headers: {'showLoading': false }}
      const body = { theme: self.theme, context: self.context }
      if (usePromptApi) {
        body.chat_name = `口說練習(${self.pageTitle} /${self.selectedAns.name}/${self.selectedAns2.name})`
      }
      self.isGettingChatsCreate = true
      await api.post(path, body, options)
      .then((res) => {
        if (revision !== self.chatRevision) return
        self.$store.dispatch('getRemainPoints')
        self.session_id = res.data.session

        self.setDataWithPractice(res.data.result)

        self.isBegin = false
        self.selectedStep = 1

      })
      .catch((err) => {
        if (revision !== self.chatRevision) return
        obj.isLoading = false
        obj.text = '無法開始對話，請點「重新開始」再試一次。'
        console.log(err)
      })
      .finally(() => {
        if (revision === self.chatRevision) self.isGettingChatsCreate = false
      })
    },

    generateSentence () {
      // 實用句
      let self = this

      let path = `/ai/generate/sentence`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      self.follow_upObj.push(obj)
      const options = { headers: {'showLoading': false }}
      api.post(path, {
        theme: self.theme,
        context: self.context
      }, options)
      .then((res) => {
        self.$store.dispatch('getRemainPoints')
        self.setDataWithFollow(res.data.result)
          self.$nextTick(() => {
          self.scrollToBottom()
        })
      })
      .catch(() => {
      })
    },

    chatsContinue (text) {
      if (this.speechInputDisabled || this.speechStatus.busy || !text.trim()) return
      // 繼續對話
      let self = this
      const revision = self.chatRevision
      self.isSendingChat = true

      let path = `/ai/chats/${self.session_id}`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      self.conversationObj.push(obj)
      const options = { headers: {'showLoading': false }}
      api.post(path, {
        content: text,
        audio: self.audio_id
      }, options)
      .then((res) => {
        if (revision !== self.chatRevision) return
        self.$store.dispatch('getRemainPoints')
        self.setDataWithPractice(res.data.result)

        self.audio_id = ''
      })
      .catch(() => {
        if (revision === self.chatRevision) self.conversationObj.pop()
      })
      .finally(() => {
        if (revision === self.chatRevision) self.isSendingChat = false
      })
    },

    getHistory () {
      let self = this
      const revision = self.chatRevision
      let path = `ai/chats/${self.session_id}/history`
      const options = { headers: {'showLoading': false }}
      api.get(path, options)
      .then((res) => {
        if (revision === self.chatRevision) self.chatHistory = res.data.records
      })
      .catch((err) => {
        console.log(err)
      })
    },

    async setDataWithFollow (result) {
      let self = this

      // let index = self.follow_upObj.findIndex(a => {
      //   return a.isLoading
      // })
      let index = self.follow_upObj.findIndex(x => x.isLoading === true)

      self.follow_upObj[index].isLoading = false
      self.follow_upObj[index].text = result
      self.follow_upObj[index].ttsUrl = await this.getTTSUrl('female', result)
      self.follow_upObj[index].translate = null
    },

    async setDataWithPractice (result) {
      let self = this
      const revision = self.chatRevision
      const message = self.conversationObj.find(x => x.isLoading === true)
      if (!message) return

      message.isLoading = false
      message.text = result
      self.lastChatResult = result
      const ttsUrl = await self.getTTSUrl('female', result)
      if (revision !== self.chatRevision) return
      message.ttsUrl = ttsUrl
      const translate = await self.get_Translate_Dialog(self.theme, self.context, result)
      if (revision !== self.chatRevision) return
      message.translate = translate

      self.$nextTick(() => {
        if (revision !== self.chatRevision) return
        self.scrollToBottom()
        self.getHistory()
      })
    },

    reStart () {
      this.chatRevision++
      this.resetSpeechDraft()
      this.isBegin = true
      this.selectedStep = 0
      this.isAiSuggest = false
      this.isTranslateBtn = false

      this.selectedAns = null
      this.selectedAns2 = null
      this.session_id = null
      this.prompt_id = null
      this.pageTitle = ''
      this.chatJSon = null
      this.lastChatResult = null
      this.chatHistory = []
      this.isGettingChatsCreate = false
      this.isSendingChat = false

      this.chatObj = this.$options.data().chatObj
      this.follow_upObj = []
      this.conversationObj = this.$options.data().conversationObj

      this.$forceUpdate()
      const loading = this.getCategories()

      this.$store.dispatch('setPlayBackRate', 1)
      this.$store.dispatch('toggleSubtitle', true)
      return loading
    },

    scrollToBottom () {
      let self = this
      if (self.chatObj.length > 0 || self.conversationObj.length > 0) {
        const element = self.$refs.chatContent
        const element1 = self.$refs.chatContent1
        const element2 = self.$refs.chatContent2

        if (element && element.scrollHeight > element.offsetHeight) {
          element.scrollTop = element.scrollHeight
        }
        if (element1 && element1.scrollHeight > element1.offsetHeight) {
          element1.scrollTop = element1.scrollHeight
          self.$nextTick(() => {
            element1.scrollTop = element1.scrollHeight
          })
        }
        if (element2 && element2.scrollHeight > element2.offsetHeight) {
          element2.scrollTop = element2.scrollHeight
          self.$nextTick(() => {
            element2.scrollTop = element2.scrollHeight
          })
        }

      }

    },

    selectAnswer (selectAnswer) {
      let self = this
      if (selectAnswer.name !== '我有其他想法') {
        if (selectAnswer.items) {
          self.selectedAns = selectAnswer

          self.chatObj.push({ role: 'self', text: selectAnswer.name })
          self.chatObj.push({ role: 'robot', text: `你想在${selectAnswer.name}做什麼呢？`, options: selectAnswer.items })

          if (self.selectedAns2) {
            self.selectedAns2 = null
          }
        } else {
          if (selectAnswer.pre_name !== self.selectedAns.name) {
            let index = self.chatJSon.findIndex(x => x.name === selectAnswer.pre_name)
            self.selectedAns = self.chatJSon[index]
          }
          self.selectedAns2 = selectAnswer

          self.chatObj.push({ role: 'self', text: selectAnswer.name })
        }
      } else {
        self.$refs.input1.focus()
      }
    },

    inputText () {
      let self = this

      if (self.selfText) {
        if (selectAnswer.items) {
          self.selectedAns = {
            name: self.selfText,
            name_en: self.selfText,
            theme_practical: self.selfText,
            theme_chat: self.selfText
          }

          self.chatObj.push({ role: 'self', text: selectAnswer.name })
          self.chatObj.push({ role: 'robot', text: `你想在${selectAnswer.name}做什麼呢？`, options: selectAnswer.items })

          if (self.selectedAns2) {
            self.selectedAns2 = null
          }
        } else {
          self.selectedAns2 = {
            name: self.selfText,
            name_en: self.selfText,
            theme_practical2: self.selfText,
            theme_chat2: self.selfText,
            context_practical: self.selfText,
            context_chat: self.selfText
          }

          self.chatObj.push({ role: 'self', text: selectAnswer.name })
        }
      }
    },

    inputText2 () {},

    inputText3 () {
      if (this.speechInputDisabled || this.speechStatus.busy) return
      let self = this
      if (self.selfText.trim().length > 0 && self.remainPoints > 0) {
        self.conversationObj.push({ role: 'self', text: self.selfText })

        self.chatsContinue(self.selfText)

        self.selfText = ''

        self.isAiSuggest = false

      } else if (self.remainPoints < 1) {
        self.swal_failPopPoints('點數不足')
      }
    },

    toSlide(i) {
      this.selectedStep = i
    },

    selectType (selectType) {
      let self = this
      if (self.remainPoints > 0) {
        self.isBegin = false
        if (selectType === 'record') {
          self.selectedStep = 0
          self.toSlide(0)
          self.generateSentence()
        } else if (selectType === 'practice') {
          self.selectedStep = 1
          self.toSlide(1)
          !self.isGettingChatsCreate ? self.chatsCreate() : null
        }
      } else {
        self.swal_failPopPoints('點數不足')
      }
    },

    onPageChange(currentPage) {
      if (currentPage === 0) {
        if (this.follow_upObj.length < 1 && this.conversationObj.length > 0) {
          this.generateSentence()
        }
      } else {
        if (this.follow_upObj.length > 0 && this.conversationObj.length < 1) {
          this.chatsCreate()
        }
      }
    },

    speechCountDown (speechCountDown) {
      this.isSpeechRecognition = speechCountDown.isSpeechRecognition
      this.speechCount = speechCountDown.count
    },

    toggleTranslateBtn () {
      this.isTranslateBtn = !this.isTranslateBtn
      this.isAiSuggest = false
    },

    toggleAISuggest () {
      if (this.lastChatResult && this.remainPoints > 0) {
        this.isAiSuggest = !this.isAiSuggest
        this.isTranslateBtn = false
      } else if (this.remainPoints < 1) {
        this.swal_failPopPoints('點數不足')
      }
    },

    swal_failPopPoints (text) {
      let self = this
      let defaultTitle = text ?  `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
      self.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'save_check my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },
    swal_failPopUp (text) {
      let self = this
      let defaultTitle = text ?  `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`
      self.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },
    swal_failPopAPI () {
      let self = this
      self.$swal({
        html: `<p>請重新輸入</p>`,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: `我知道了`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-center items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
        .then((result) => {
          console.log(result)
          if (result) {
            self.isDisabledInput = false
          }
        }
      )
    },

    emitTalkIdolIdx (emitTalkIdolIdx) {
      this.TalkingIdolIdx = emitTalkIdolIdx
    },

    toggleTips () {
      let self = this
      const htmlText = `
        <h6 class="font-bold text-lg">操作說明：</h6>
        <p class="mb-2">1. 點<img src="${require('@/assets/image/ai/mic_C.png')}" class="inline-block icon-img mx-1">說出回應的句子，再點
          <img src="${require('@/assets/image/ai/submit_icon.png')}" class="inline-block icon-img mx-1">，送出回應。</p>
        <p class="mb-2">2. 點<img src="${require('@/assets/image/ai/AI_A.png')}" class="inline-block icon-img mx-1">參考 AI 回應內容，並練習說說看。</p>
        <p class="mb-2">3. 點<img src="${require('@/assets/image/ai/translate_btn_off.png')}" class="inline-block icon-img mx-1">輸入想翻譯的中文。</p>
        <p class="mb-2">4. 點<img src="${require('@/assets/image/ai/btn_AItalk_voice.png')}" class="inline-block icon-img mx-1">聆聽自己的錄音。</p>
        <p class="mb-2">5. 點<img src="${require('@/assets/image/ai/btn_AItalk_correct.png')}" class="inline-block icon-img mx-1">觀看 AI 反饋建議，讓自己下次說得更好。</p>
        <p class="mb-2">6. 若 AI 回應不符預期，請修改文字內容或點擊重新整理。</p>
      `
      return self.$swal({
        html: htmlText,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: `關閉`,
        title: '溫馨提醒',
        position: window.innerWidth < 768 ? 'top' : 'center',
        customClass: {
          title: 'text-white text-2xl',
          popup: 'p-0',
          header: 'justify-center items-center swal_tips',
          htmlContainer: 'my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-deny'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.speech-submit { padding: 0; border: 0; background: transparent; }
.speech-submit:disabled { cursor: default; }
.speech-submit:focus-visible { outline: 3px solid #6a69ad; outline-offset: 3px; }
.ai_chat {
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
  .swiper_item {
    min-height: 600px;
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 8);
      padding: 0.5rem;
    }
  }
  .swiper_rule {
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 4);
      padding: 0.5rem;
    }
  }
  // .swiper-item {
  //   @media (min-width: 1024px) {
  //     padding: 1.5rem !important;
  //   }
  //   @media (min-width: 640px) {
  //     padding-left: 1.5rem !important;
  //     padding-right: 1.5rem !important;
  //   }
  // }
  .opacity-50{
    opacity: 0.5;
  }
  font-family: x-locale-heading-primary, zillaslab, Palatino, "Palatino Linotype", x-locale-heading-secondary, 'Source Han Serif SC', "STZhongsong", "Source Han Sans CN", 'PingFang SC', 'Myriad Pro', 'Hiragino Sans GB', "SimHei";
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  // padding-left: 5em;
  // padding-right : 5em;
  // @media (max-width: 1024px) {
  //   padding-left: 0;
  //   padding-right : 0;
  // }
  .VueCarousel-navigation-next {
    width: 68px;
    height: 538px;
    background: linear-gradient(272.05deg, #D4D5E1 1.95%, #FFFFFF 42.8%);
  }
  .follow-btn {
    a {
      height: 3.5em;
      &:hover {
        text-decoration: none !important;
      }
    }
  }
}
  .tips-btns {
    top: 0%;
    right: 0;
      padding-top: 82px;
    }
  .chat-content {
    height: calc(60vh);
    overflow-y: scroll;
    overflow-x: hidden;
    @media (max-width: 640px) {
      height: calc(50vh);
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
    }

    ::-webkit-scrollbar {
      width: 6px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    .tips-content {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .tips-shadow-bg {
        width: 8%;
        background:rgba(0, 0, 0, 0.7);
      }
      .tips-right {
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }
  .ai-suggest-button {
    width: 3rem !important;
    height: 3rem !important;
    margin-right: .25rem !important;
  }
  .chat-button {
    padding-top: .75rem !important;
    padding-bottom: .75rem !important;

    .chat-button-input  {
      border-radius: 53px;
      img {
        height: 28px;
        width: auto;
      }
    }
  }

  .keyboard-btn {
    img {
      height: 25px;
      width: auto;
    }
  }
  .notOpenKeyboard {
  }
  .openKeyboard {
    img {
      height: 54px;
      width: auto;
    }
  }
  .microphone-btn {
    background-color: #5A5D9B;
    padding: .8rem 6.5rem;
    border-radius: 53px;
    img {
      height: 26px;
      width: auto;
    }
  }
  .aiSuggestDialogue {
    min-height: 52px;
    @media (max-width: 1024px) {
      min-height: 172px;
    }
  }
</style>
